<template>
    <div class="course-container">
        <!--详情-->
        <div class="topic-detail" v-if="showMode==='view'">
            <div class="sub-topic-top">
                <div class="topic-top-left">
                    <div class="top-left1">
                        <div style="margin-right: 10px;">课题引领</div>
                        <div v-if="info.status===0" class="status-info-cs">初始阶段</div>
                        <div v-if="info.status===1" class="status-info-bm">申报阶段</div>
                        <div v-if="info.status===2" class="status-info-kt">开题论证</div>
                        <div v-if="info.status===3" class="status-info-zq">中期检查</div>
                        <div v-if="info.status===4" class="status-info-jt">结题验收</div>
                        <div v-if="info.status===5" class="status-info-js">课题结束</div>
                    </div>
                    <div class="top-left2">
                        <span v-if="info.status===0||info.status===1">申报阶段&nbsp;&nbsp; {{ timestampToTime(info.applyBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.applyEndTime)}}</span>
                        <span v-if="info.status===2">开题论证&nbsp;&nbsp; {{ timestampToTime(info.ktBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.ktEndTime)}}</span>
                        <span v-if="info.status===3">中期检查&nbsp;&nbsp; {{ timestampToTime(info.beginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.endTime)}}</span>
                        <span v-if="info.status===4">结题验收&nbsp;&nbsp; {{ timestampToTime(info.jtBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.jtEndTime)}}</span>
                        <span v-if="info.status===5">课题已结束</span>
                    </div>
                </div>
                <div class="topic-top-right">
                    <!--申报阶段-->
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===0">
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===0">
                        <div class="bm-btn" @click="topicSignUp('立即报名')">立即报名</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.sbStatus!==3">
                        <div class="bm-btn" @click="topicSignUp('保存')">报名编辑</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.sbStatus===3">
                        <div class="bm-btn" @click="viewTopicSignUp">查看资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&(this.signForm.sbStatus===1||this.signForm.sbStatus===2)">
                        <div class="bm-btn bg-dsh">待审核</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.sbStatus===3">
                        <div class="bm-btn bg-ytg">已通过</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.sbStatus===4">
                        <div class="bm-btn bg-wtg">未通过</div>
                    </div>
                    <!--开题阶段-->
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.ktStatus===0">
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.ktStatus===0">
                        <div class="bm-btn" @click="uploadKtFile">上传资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&(this.signForm.ktStatus!==0&&this.signForm.ktStatus!==3)">
                        <div class="bm-btn" @click="uploadKtFile">编辑资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.ktStatus===3">
                        <div class="bm-btn" @click="viewTopicSignUp">查看资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&(this.signForm.ktStatus===1||this.signForm.ktStatus===2)">
                        <div class="bm-btn bg-dsh">待审核</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.ktStatus===3">
                        <div class="bm-btn bg-ytg">已通过</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.ktStatus===4">
                        <div class="bm-btn bg-wtg">未通过</div>
                    </div>
                    <!--中期阶段-->
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&this.signForm.zqStatus===0">
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&this.signForm.zqStatus===0">
                        <div class="bm-btn" @click="uploadZqFile">上传资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&this.signForm.zqStatus!==3&&this.signForm.zqStatus!==0">
                        <div class="bm-btn" @click="uploadZqFile">编辑资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&this.signForm.zqStatus===3">
                        <div class="bm-btn" @click="viewTopicSignUp">查看资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&(this.signForm.zqStatus===1||this.signForm.zqStatus===2)">
                        <div class="bm-btn bg-dsh">待审核</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&this.signForm.zqStatus===3">
                        <div class="bm-btn bg-ytg">已通过</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&this.signForm.zqStatus===4">
                        <div class="bm-btn bg-wtg">未通过</div>
                    </div>
                    <!--结题阶段-->
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&this.signForm.jtStatus===0">
                    </div>
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&this.signForm.jtStatus===0">
                        <div class="bm-btn" @click="uploadJtFile">上传资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&this.signForm.jtStatus!==3&&this.signForm.jtStatus!==0">
                        <div class="bm-btn" @click="uploadJtFile">编辑资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&this.signForm.jtStatus===3">
                        <div class="bm-btn" @click="viewTopicSignUp">查看资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&(this.signForm.jtStatus===1||this.signForm.jtStatus===2)">
                        <div class="bm-btn bg-dsh">待审核</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&this.signForm.jtStatus===3">
                        <div class="bm-btn bg-ytg">已通过</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&this.signForm.jtStatus===4">
                        <div class="bm-btn bg-wtg">未通过</div>
                    </div>
                </div>
            </div>

            <div class="topic-container">
                <div class="topic-name-container">
                    {{info.topicName}}
                </div>

                <div class="topic-time-container">
                    <div class="topic-time-top">
                        <div class="topic-time-top1">
                            <svg t="1745994882084" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9405" width="18" height="18"><path d="M597.333333 618.666667h149.333334c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666667H597.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667s17.066667 42.666667 42.666666 42.666667zM597.333333 832h149.333334c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666666H597.333333c-25.6 0-42.666667 17.066667-42.666666 42.666666s17.066667 42.666667 42.666666 42.666667zM277.333333 618.666667H426.666667c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666667H277.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667s17.066667 42.666667 42.666666 42.666667zM277.333333 832H426.666667c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666666H277.333333c-25.6 0-42.666667 17.066667-42.666666 42.666666s17.066667 42.666667 42.666666 42.666667z" p-id="9406" fill="#0d55a4"></path><path d="M874.666667 85.333333h-128V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667v42.666666h-298.666666V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667v42.666666h-128C89.6 85.333333 42.666667 132.266667 42.666667 192v725.333333C42.666667 977.066667 89.6 1024 149.333333 1024h725.333334c59.733333 0 106.666667-46.933333 106.666666-106.666667v-725.333333C981.333333 132.266667 934.4 85.333333 874.666667 85.333333zM128 192c0-12.8 8.533333-21.333333 21.333333-21.333333h128v42.666666c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V170.666667h298.666666v42.666666c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V170.666667h128c12.8 0 21.333333 8.533333 21.333333 21.333333V341.333333H128V192z m768 725.333333c0 12.8-8.533333 21.333333-21.333333 21.333334h-725.333334c-12.8 0-21.333333-8.533333-21.333333-21.333334V426.666667h768v490.666666z" p-id="9407" fill="#0d55a4"></path></svg>
                        </div>
                        <div class="topic-time-top2">
                            课题时间安排
                        </div>
                    </div>

                    <div class="topic-jd">
                        <div class="topic-jd1">
                            <div class="topic-point"></div>
                        </div>
                        <div class="topic-jd2">申报阶段</div>
                    </div>
                    <div class="topic-jd-time">
                        {{ timestampToTime(info.applyBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.applyEndTime)}}
                    </div>

                    <div class="topic-jd">
                        <div class="topic-jd1">
                            <div class="topic-point"></div>
                        </div>
                        <div class="topic-jd2">开题论证</div>
                    </div>
                    <div class="topic-jd-time">
                        {{ timestampToTime(info.ktBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.ktEndTime)}}
                    </div>

                    <div class="topic-jd">
                        <div class="topic-jd1">
                            <div class="topic-point"></div>
                        </div>
                        <div class="topic-jd2">中期检查</div>
                    </div>
                    <div class="topic-jd-time">
                        {{ timestampToTime(info.beginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.endTime)}}
                    </div>

                    <div class="topic-jd">
                        <div class="topic-jd1">
                            <div class="topic-point"></div>
                        </div>
                        <div class="topic-jd2">结题验收</div>
                    </div>
                    <div class="topic-jd-time-end">
                        {{ timestampToTime(info.jtBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.jtEndTime)}}
                    </div>
                </div>

                <div class="topic-title-container">
                    <div class="topic-title-container1">
                        <svg t="1745994994411" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10489" width="24" height="24"><path d="M210.823529 839.183059V120.470588H146.040471C114.672941 120.470588 90.352941 152.997647 90.352941 180.976941v787.681883C90.352941 987.030588 100.020706 1024 146.040471 1024h621.492705C782.351059 1024 813.176471 1008.941176 813.176471 968.643765V918.588235H290.590118C245.955765 918.588235 210.823529 872.779294 210.823529 839.183059zM786.808471 180.705882h160.015058L768 0v162.590118c0 12.182588 6.144 18.115765 18.808471 18.115764z" p-id="10490" fill="#0d55a4"></path><path d="M786.808471 195.764706C765.906824 195.764706 752.941176 183.055059 752.941176 162.590118V0H275.531294C246.287059 0 225.882353 21.443765 225.882353 51.772235L226.123294 120.470588H225.882353v718.712471C225.882353 865.249882 258.514824 903.529412 290.590118 903.529412H881.935059C912.384 903.529412 948.705882 868.201412 948.705882 839.183059V195.764706H786.808471zM813.176471 692.705882H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058824s-6.776471 15.058824-15.058823 15.058823z m0-225.882353H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058824s-6.776471 15.058824-15.058823 15.058823z m0-210.823529H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058823s-6.776471 15.058824-15.058823 15.058824z" p-id="10491" fill="#0d55a4"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        基础信息
                    </div>
                </div>
                <div class="topic-base-info-container">
                    <div class="base-one-container">
                        <div class="base-one-info-80">课题名称：<span style="color: #767676">{{info.parentTopicName}}</span></div>
                    </div>
                </div>
                <div class="topic-base-info-container">
                    <div class="base-one-container">
                        <div class="base-one-info-80">子课题名称：<span style="color: #767676">{{info.topicName}}</span></div>
                    </div>
                </div>
                <div class="topic-base-info-container">
                    <div class="base-one-container">
                        <div class="base-one-info">课题负责人：<span style="color: #767676">{{info.leaderNames}}</span></div>

                        <div class="base-one-info">子课题负责人：<span style="color: #767676">{{info.sonLeaderNames}}</span></div>
                    </div>
                </div>
                <div class="topic-base-info-container">
                    <div class="base-one-container">
                        <div class="base-one-info">课题级别：<span style="color: #767676">{{info.topicLevelName}}</span></div>
                        <div class="base-one-info">课题方向：<span style="color: #767676">{{info.topicClassifyName}}</span></div>
                    </div>
                </div>
                <div class="topic-base-info-container">
                    <div class="base-one-container">
                        <div class="base-one-info">课题单位：<span style="color: #767676">{{info.orgTxt}}</span></div>
                        <div class="base-one-info">联系方式：<span style="color: #767676">{{info.contactInfo}}</span></div>
                    </div>
                </div>

                <div class="topic-title-container" v-if="info.recommend">
                    <div class="topic-title-container1">
                        <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        课题介绍
                    </div>
                </div>
                <div class="topic-content-container" v-if="info.recommend">
                    {{info.recommend}}
                </div>

                <div class="topic-title-container" v-if="info.studyAim">
                    <div class="topic-title-container1">
                    </div>
                    <div class="topic-title-container2">
                        研究目的
                    </div>
                </div>
                <div class="topic-content-container" v-if="info.studyAim">
                    {{info.studyAim}}
                </div>

                <div class="topic-title-container" v-if="info.studyMethod">
                    <div class="topic-title-container1">
                    </div>
                    <div class="topic-title-container2">
                        研究方法
                    </div>
                </div>
                <div class="topic-content-container" v-if="info.studyMethod">
                    {{info.studyMethod}}
                </div>

                <div class="topic-title-container" v-if="info.remarks">
                    <div class="topic-title-container1">
                        <svg t="1746002797480" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16363" width="24" height="24"><path d="M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m0-819.2a51.2 51.2 0 1 0 51.2 51.2 51.2 51.2 0 0 0-51.2-51.2z m51.2 256a51.2 51.2 0 0 0-102.4 0v307.2a51.2 51.2 0 0 0 102.4 0V460.8z" fill="#0d55a4" p-id="16364"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        其他说明
                    </div>
                </div>
                <div class="topic-content-container" v-if="info.remarks">
                    {{info.remarks}}
                </div>

                <div class="topic-title-container">
                    <div class="topic-title-container1">
                        <svg t="1746001513851" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15262" width="24" height="24"><path d="M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m128 502.613A128 128 0 0 1 502.613 640l-216.746 98.133L384 521.387A128 128 0 0 1 521.387 384l216.746-98.133z" fill="#0d55a4" p-id="15263"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        课题附件
                    </div>
                </div>
                <div class="file-list">
                    <div class="file-item" v-for="item in info.fileList" :key="item">
                        <div class="file-title" style="text-indent: 30px" @click="downloadFile(item)">{{item.fileName}}</div>
                        <div class="file-view">
                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                      :src="require('@/assets/file/file_view_color.png')"
                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                            </el-image>
                        </div>
                        <div class="file-view" @click="downloadFile(item)">
                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                        </div>
                    </div>
                </div>

                <!--立项与基础材料-->
                <div class="topic-title-container" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-title-container1">
                        <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        立项与基础材料
                    </div>
                </div>
                <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-file-item-title">
                        立项申报书
                    </div>
                    <div class="file-list">
                        <div class="file-item-second" v-for="item in releaseInfo.sbsFileList" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                </el-image>
                            </div>
                            <div class="file-view" @click="downloadFile(item)">
                                <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                            </div>
                        </div>
                        <div class="div-100"  v-if="releaseInfo.sbsFileList&&releaseInfo.sbsFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无此类文件" />
                        </div>
                    </div>
                </div>
                <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-file-item-title">
                        <span style="color: red">*</span>立项通知书
                    </div>
                    <div class="file-list">
                        <div class="file-item-second" v-for="item in releaseInfo.tzsFileList" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                </el-image>
                            </div>
                            <div class="file-view" @click="downloadFile(item)">
                                <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                            </div>
                        </div>
                        <div class="div-100"  v-if="releaseInfo.tzsFileList&&releaseInfo.tzsFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无此类文件" />
                        </div>
                    </div>
                </div>

                <!--开题报告-->
                <div class="topic-title-container" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-title-container1">
                        <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        开题报告
                    </div>
                </div>
                <div class="file-list" v-if="info.isRelease===1&&info.status===5">
                    <div class="file-item" v-for="item in releaseInfo.ktbgFileList" :key="item">
                        <div class="file-title" style="text-indent: 30px" @click="downloadFile(item)">{{item.fileName}}</div>
                        <div class="file-view">
                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                      :src="require('@/assets/file/file_view_color.png')"
                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                            </el-image>
                        </div>
                        <div class="file-view" @click="downloadFile(item)">
                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                        </div>
                    </div>
                </div>

                <!--成果类材料-->
                <div class="topic-title-container" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-title-container1">
                        <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#0d55a4" p-id="12410"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        成果类材料
                    </div>
                </div>

                <div class="topic-sign-title-second" v-if="info.isRelease===1&&info.status===5">
                    核心报告类材料
                </div>
                <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-file-item-title">
                        <span style="color: red">*</span>结题报告
                    </div>
                    <div class="file-list">
                        <div class="file-item-second" v-for="item in releaseInfo.jtbgFileList" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                </el-image>
                            </div>
                            <div class="file-view" @click="downloadFile(item)">
                                <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                            </div>
                        </div>
                        <div class="div-100"  v-if="releaseInfo.jtbgFileList&&releaseInfo.jtbgFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无此类文件" />
                        </div>
                    </div>
                </div>

                <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-file-item-title">
                        工作报告
                    </div>
                    <div class="file-list">
                        <div class="file-item-second" v-for="item in releaseInfo.gzbgFileList" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                </el-image>
                            </div>
                            <div class="file-view" @click="downloadFile(item)">
                                <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                            </div>
                        </div>
                        <div class="div-100" v-if="releaseInfo.gzbgFileList&&releaseInfo.gzbgFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无此类文件" />
                        </div>
                    </div>
                </div>

                <div class="topic-sign-title-second" v-if="info.isRelease===1&&info.status===5">
                    成果类材料
                </div>
                <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-file-item-title">
                        论文与著作
                    </div>
                    <div class="file-list">
                        <div class="file-item-second" v-for="item in releaseInfo.lwzzFileList" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                </el-image>
                            </div>
                            <div class="file-view" @click="downloadFile(item)">
                                <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                            </div>
                        </div>
                        <div class="div-100" v-if="releaseInfo.lwzzFileList&&releaseInfo.lwzzFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无此类文件" />
                        </div>
                    </div>
                </div>

                <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-file-item-title">
                        <span style="color: red">*</span>教学案例与课件
                    </div>
                    <div class="file-list">
                        <div class="file-item-second" v-for="item in releaseInfo.alkjFileList" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                </el-image>
                            </div>
                            <div class="file-view" @click="downloadFile(item)">
                                <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                            </div>
                        </div>
                        <div class="div-100" v-if="releaseInfo.alkjFileList&&releaseInfo.alkjFileList.length===0">
                            <dataEmpty :is-img="false"  title="暂无此类文件" />
                        </div>
                    </div>
                </div>

                <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-file-item-title">
                        获奖证书
                    </div>
                    <div class="file-list">
                        <div class="file-item-second" v-for="item in releaseInfo.hjzsFileList" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                </el-image>
                            </div>
                            <div class="file-view" @click="downloadFile(item)">
                                <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                            </div>
                        </div>
                        <div class="div-100" v-if="releaseInfo.hjzsFileList&&releaseInfo.hjzsFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无此类文件" />
                        </div>
                    </div>
                </div>


                <div class="topic-sign-title-second" v-if="info.isRelease===1&&info.status===5">
                    附件
                </div>
                <div class="topic-file-container-second" v-if="info.isRelease===1&&info.status===5">
                    <div class="topic-file-item-title">
                        附件
                    </div>
                    <div class="file-list">
                        <div class="file-item-second" v-for="item in releaseInfo.fbfjFileList" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view_color.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                </el-image>
                            </div>
                            <div class="file-view" @click="downloadFile(item)">
                                <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                            </div>
                        </div>
                        <div class="div-100" v-if="releaseInfo.fbfjFileList&&releaseInfo.fbfjFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无此类文件" />
                        </div>
                    </div>
                </div>

            </div>

            <div class="back-btn-container">
                <div class="apply-btn-back" @click="changeModel">返回</div>
            </div>
        </div>
        <!--报名资料-->
        <div class="topic-detail" v-show="showMode==='sign'">
            <div class="topic-sign-container">
                <div class="topic-sign-title">课题报名</div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <el-form ref="signForm" :model="signForm"
                             :rules="signRules"
                             label-position="top">
                        <div class="topic-sign-title">基本信息</div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="教师姓名" prop="trueName">
                                    <el-input disabled v-model="signForm.trueName" placeholder="请输入教师姓名"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="所属学校" prop="trueName">
                                    <el-input disabled v-model="signForm.orgName" placeholder="请输入所属学校"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="任教学段" prop="periodKey">
                                    <el-select @change="changePeriod" style="width: 100%;" v-model="signForm.periodKey"
                                               placeholder="请选择任教学段">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="任教学科" prop="subjectKey">
                                    <el-select style="width: 100%;" v-model="signForm.subjectKey"
                                               placeholder="请选择任教学科">
                                        <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="最高学历" prop="qualificationKey">
                                    <el-select style="width: 100%;" v-model="signForm.qualificationKey"
                                               placeholder="请选择最高学历">
                                        <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="技术职称" prop="rankLevel">
                                    <el-select style="width: 100%;" v-model="signForm.rankLevel"
                                               placeholder="请选择技术职称">
                                        <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="topic-sign-title">附件说明</div>
                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>最高学历证书上传
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="xlFileList"
                                           :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                           :headers="{ token }"
                                           :limit="1"
                                           :on-remove="handleFileRemove"
                                           :data="{ topicStatus: 1, topicFileType: 1}"
                                           accept=".pdf,.jpg,.png,"
                                           :before-upload="beforeXlUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>职称证书上传
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="zcFileList"
                                           :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                           :headers="{ token }"
                                           :limit="1"
                                           :on-remove="handleFileRemove"
                                           :data="{ topicStatus: 1, topicFileType: 2}"
                                           accept=".pdf,.jpg,.png,"
                                           :before-upload="beforeZcUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                参与相关课题证明材料
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="clFileList"
                                           :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                           :headers="{ token }"
                                           :on-remove="handleFileRemove"
                                           :data="{ topicStatus: 1, topicFileType: 3}"
                                           accept=".pdf,.doc,.docx,"
                                           :before-upload="beforeClUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：pdf&nbsp;word &nbsp;&nbsp; 大小限制：10M
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                补充说明
                            </div>
                            <div>
                                <el-input
                                  v-model="signForm.remarks"
                                  :rows="4"
                                  type="textarea"
                                  placeholder=""
                                />
                            </div>
                        </div>
                    </el-form>
                    <div class="apply-btn-container">
                        <div class="apply-btn" @click="submitTopicSign">
                            确定
                        </div>
                        <div class="apply-btn-back" @click="backTopicInfo">
                            返回
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--开题资料-->
        <div class="topic-detail" v-show="showMode==='ktFile'">
            <div class="topic-sign-container">
                <div class="topic-sign-title" >
                    开题资料上传
                </div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>立项与基础材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            立项申报书
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="sbsFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 2, topicFileType: 1}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            <span style="color: red">*</span>立项通知书
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="tzsFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 2, topicFileType: 2}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeZcUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>开题报告</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            <span style="color: red">*</span>开题报告
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="ktbgFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 2, topicFileType: 3}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>辅助材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            活动记录表
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="hdjlFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 2, topicFileType: 4}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            问卷与访谈提纲
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="wjftFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 2, topicFileType: 5}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>附件</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            附件
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="ktfjFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 2, topicFileType: 6}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>
                            </el-upload>
                        </div>
                    </div>

<!--                    <div class="apply-btn-container">-->
<!--                        <div v-if="applyBtnTxt!=='查看资料'" class="apply-btn" @click="submitKtFile">确认</div>-->
<!--                    </div>-->
                    <div class="apply-btn-container">
                        <div class="apply-btn" @click="submitKtFile">
                            确定
                        </div>
                        <div class="apply-btn-back" @click="backTopicInfo">
                            返回
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--中期资料-->
        <div class="topic-detail" v-show="showMode==='zqFile'">
            <div class="topic-sign-container">
                <div class="topic-sign-title" >
                    中期资料上传
                </div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>核心报告类材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            <span style="color: red">*</span>中期报告
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="zqbgFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 3, topicFileType: 1}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            研究过程记录
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="yjgcFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 3, topicFileType: 2}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeZcUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>问题分析与调整计划</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            问题清单
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="wtqdFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 3, topicFileType: 3}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            后续研究计划
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="hxjhFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 3, topicFileType: 4}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>附件</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            附件
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="zqfjFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 3, topicFileType: 5}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>
                            </el-upload>
                        </div>
                    </div>

<!--                    <div class="apply-btn-container">-->
<!--                        <div v-if="applyBtnTxt!=='查看资料'" class="apply-btn" @click="submitZqFile">确认</div>-->
<!--                    </div>-->
                    <div class="apply-btn-container">
                        <div class="apply-btn" @click="submitZqFile">
                            确定
                        </div>
                        <div class="apply-btn-back" @click="backTopicInfo">
                            返回
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--结题资料-->
        <div class="topic-detail" v-show="showMode==='jtFile'">
            <div class="topic-sign-container">
                <div class="topic-sign-title" >
                    验收资料上传
                </div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>核心报告类材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            <span style="color: red">*</span>结题报告 <span class="item-title-tio">需包含研究背景与意义、目标与内容、方法与过程、成果与结论、创新点与实践价值等，字数要求1万字以上</span>
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="jtbgFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 4, topicFileType: 1}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            工作报告 <span class="item-title-tio">总结课题实施的全过程，包括团队分工、研究活动、经费使用等，突出研究的管理与协调。</span>
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="gzbgFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 4, topicFileType: 2}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeZcUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>成果类材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            论文与著作<span class="item-title-tio">公开发表的论文（需围绕课题主题，至少2篇以上）、专著或校本教材。</span>
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="lwzzFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 4, topicFileType: 3}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            教学案例与课件<span class="item-title-tio">教学设计方案、课堂实录视频、学生作品集等。</span>
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="alkjFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 4, topicFileType: 4}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            获奖证书<span class="item-title-tio">师生与课题相关的荣誉证书（如教学比赛奖项、学生竞赛成果）。</span>
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="hjzsFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 4, topicFileType: 5}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>

                            </el-upload>
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>附件</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            附件<span class="item-title-tio">PPT或演讲稿等附件</span>
                        </div>
                        <div>
                            <el-upload class="upload-demo"
                                       v-model:file-list="jtfjFileList"
                                       :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                       :headers="{ token }"
                                       :limit="1"
                                       :on-remove="handleFileRemove"
                                       :data="{ topicStatus: 4, topicFileType: 6}"
                                       accept=".pdf,.jpg,.png,"
                                       :before-upload="beforeXlUpload">
                                <div style="display: flex">
                                    <div class="upload-btn-container">
                                        <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                        <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                    </div>
                                    <div class="upload-btn-tip">
                                        支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                    </div>
                                </div>
                            </el-upload>
                        </div>
                    </div>

<!--                    <div class="apply-btn-container">-->
<!--                        <div v-if="applyBtnTxt!=='查看资料'" class="apply-btn" @click="submitJtFile">确认</div>-->
<!--                    </div>-->
                    <div class="apply-btn-container">
                        <div class="apply-btn" @click="submitJtFile">
                            确定
                        </div>
                        <div class="apply-btn-back" @click="backTopicInfo">
                            返回
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--查看资料-->
        <div class="topic-detail" v-show="showMode==='viewApply'">
            <!--报名资料-->
            <div class="topic-sign-container" v-if="info.status===1">
                <div class="topic-sign-title">查看课题报名资料</div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <el-form ref="signForm" :model="signForm"
                             :rules="signRules"
                             label-position="top">
                        <div class="topic-sign-title">基本信息</div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="教师姓名" prop="trueName">
                                    <el-input disabled v-model="signForm.trueName" placeholder="请输入教师姓名"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="所属学校" prop="trueName">
                                    <el-input disabled v-model="signForm.orgName" placeholder="请输入所属学校"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="任教学段" prop="periodKey">
                                    <el-select disabled @change="changePeriod" style="width: 100%;" v-model="signForm.periodKey"
                                               placeholder="请选择任教学段">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="任教学科" prop="subjectKey">
                                    <el-select disabled style="width: 100%;" v-model="signForm.subjectKey"
                                               placeholder="请选择任教学科">
                                        <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="最高学历" prop="qualificationKey">
                                    <el-select disabled style="width: 100%;" v-model="signForm.qualificationKey"
                                               placeholder="请选择最高学历">
                                        <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="技术职称" prop="rankLevel">
                                    <el-select disabled style="width: 100%;" v-model="signForm.rankLevel"
                                               placeholder="请选择技术职称">
                                        <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="topic-sign-title">附件说明</div>
                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>最高学历证书上传
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in signForm.xlFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>职称证书上传
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in signForm.zcFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                参与相关课题证明材料
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in signForm.clFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                    </div>
                                </div>
                            </div>
                            <div class="div-100" v-if="signForm.clFileList&&signForm.clFileList.length===0">
                                <dataEmpty :is-img="false" title="暂无相关文件" />
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                补充说明
                            </div>
                            <div>
                                <el-input
                                  disabled
                                  v-model="signForm.remarks"
                                  :rows="4"
                                  type="textarea"
                                  placeholder=""
                                />
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
            <!--开题资料-->
            <div class="topic-sign-container" v-if="info.status===2">
                <div class="topic-sign-title">查看课题开题资料</div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>立项与基础材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            立项申报书
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.sbsFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.sbsFileList&&signForm.sbsFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            <span style="color: red">*</span>立项通知书
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.tzsFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.tzsFileList&&signForm.tzsFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>开题报告</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            <span style="color: red">*</span>开题报告
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.ktbgFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.ktbgFileList&&signForm.ktbgFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>辅助材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            活动记录表
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.hdjlFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.hdjlFileList&&signForm.hdjlFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            问卷与访谈提纲
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.wjftFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.wjftFileList&&signForm.wjftFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>附件</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            附件
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.ktfjFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.ktfjFileList&&signForm.ktfjFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>
                </div>
            </div>
            <!--中期资料-->
            <div class="topic-sign-container" v-if="info.status===3">
                <div class="topic-sign-title">查看课题中期资料</div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>核心报告类材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            <span style="color: red">*</span>中期报告
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.zqbgFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.zqbgFileList&&signForm.zqbgFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            研究过程记录
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.yjgcFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.yjgcFileList&&signForm.yjgcFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>问题分析与调整计划</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            问题清单
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.wtqdFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.wtqdFileList&&signForm.wtqdFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            后续研究计划
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.hxjhFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.hxjhFileList&&signForm.hxjhFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>附件</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            附件
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.zqfjFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.zqfjFileList&&signForm.zqfjFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>
                </div>
            </div>
            <!--结题资料-->
            <div class="topic-sign-container" v-if="info.status===4">
                <div class="topic-sign-title">查看课题结题资料</div>
                <div class="topic-sign-name">
                    {{info.topicName}}
                </div>
                <div class="topic-sign-form">
                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>核心报告类材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            <span style="color: red">*</span>结题报告
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.jtbgFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.jtbgFileList&&signForm.jtbgFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            工作报告
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.gzbgFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.gzbgFileList&&signForm.gzbgFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>成果类材料</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            论文与著作
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.lwzzFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.lwzzFileList&&signForm.lwzzFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            教学案例与课件
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.alkjFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.alkjFileList&&signForm.alkjFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            获奖证书
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.hjzsFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.hjzsFileList&&signForm.hjzsFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>

                    <div class="topic-sign-title">
                        <div>
                            <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                        </div>
                        <div>附件</div>
                    </div>
                    <div class="topic-file-container">
                        <div class="topic-file-item-title">
                            附件
                        </div>
                        <div class="file-list">
                            <div class="file-item" v-for="item in signForm.jtfjFileList" :key="item">
                                <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                <div class="file-view">
                                    <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                              :src="require('@/assets/file/file_view_color.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                    </el-image>
                                </div>
                                <div class="file-view" @click="downloadFile(item)">
                                    <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="signForm.jtfjFileList&&signForm.jtfjFileList.length===0">
                            <dataEmpty :is-img="false" title="暂无相关文件" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="apply-btn-container-back">
                <div class="apply-btn-back" @click="backTopicInfo">返回</div>
            </div>
        </div>

        <!--成功-->
        <div class="topic-detail" v-show="showMode==='success'">
            <div class="success-container">
                <div class="success-content-container">
                    <div class="success-icon">
                        <svg t="1748229463840" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3548"><path d="M512 64C265 64 64 265 64 512s201 448 448 448 448-201 448-448S759 64 512 64z m-67 627.4l-0.2-0.2-0.2 0.2-179.2-179.2 45.2-45.2 134.2 134.1 268.6-268.5 45.2 45.2L445 691.4z" fill="#0d55a4" p-id="3549"></path></svg>
                    </div>
                    <div class="success-title">资料已提交静待审核</div>
                    <div class="success-item-container">
                        <div class="success-item-title">课题名称：</div>
                        <div class="success-item-content">{{info.parentTopicName}}</div>
                    </div>
                    <div class="success-item-container">
                        <div class="success-item-title">子课题名称：</div>
                        <div class="success-item-content">{{info.topicName}}</div>
                    </div>
                    <div class="success-item-container">
                        <div class="success-item-title">申报时间：</div>
                        <div class="success-item-content">{{ timestampToTime(applyTime)}}</div>
                    </div>
                    <div class="success-btn" @click="successConfirm">确认</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {timestampDate, timestampToTime} from "@/utils/date";
import {downloadFile} from "@/api/adminservice/public";
import { serviceUrl } from "@/utils/global"
import {leadDetail,releaseTopicFile} from "@/api/admin/lead";
import {queryDict} from "@/api/admin/public";
import { signTopic,handleTopicFile } from "@/api/admin/topicSign"
import dataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "topicInfo",
    components: {dataEmpty},
    props:{
        infoId:{
            type: String,
            default:null,
        },
    },
    watch:{
        infoId(newValue,oldValue){
            this.queryInfo()
            this.getTopicReleaseFile()
        },
    },
    data() {
        return {
            serviceUrl,
            loading: false,
            pageMode:'page',
            detailMode:'view',
            signModel:'sign',
            viewApplyModel:'viewApply',
            ktFileModel:'ktFile',
            zqFileModel:'zqFile',
            jtFileModel:'jtFile',
            successMode:"success",
            failMode:"fail",
            token: this.$storage.get("token"),
            showMode:'view',
            timestampToTime,
            timestampDate,
            applyTime:Date.now(),
            info:{},
            releaseInfo:{},
            userId:"",
            periodList: [],
            subjectList: [],
            qualificationList:[],
            rankList:[],
            topicDirectionList:[],
            //按钮保存
            applyBtnTxt:'立即报名',
            //是否已申报
            isApply:0,
            /*申报*/
            xlFileList:[],//学历
            zcFileList:[],//职称证书
            clFileList:[],//参与相关课题证明材料
            signForm:{
                topicId:"",
                topicDirection:"",
                trueName:"",
                orgId:"",
                orgName:"",
                periodKey:"",
                subjectKey:"",
                qualificationKey:"",
                rankLevel:"",
                remarks:"",
                fileUrls:"",
            },
            signRules: {
                trueName: [{ required: true, message: "请输入教师姓名", trigger: "blur" },],
                orgName: [{ required: true, message: "请输入所属学校", trigger: "blur" },],
                periodKey: [{ required: true, message: "请选择任教学段", trigger: "change" },],
                subjectKey: [{ required: true, message: "请选择任教学科", trigger: "change" },],
                qualificationKey: [{ required: true, message: "请选择最高学历", trigger: "change" },],
                rankLevel: [{ required: true, message: "请选择技术职称", trigger: "change" },],
            },
            /*开题资料*/
            sbsFileList:[],//立项申报书
            tzsFileList:[],//立项通知书
            ktbgFileList:[],//开题报告
            hdjlFileList:[],//活动记录表
            wjftFileList:[],//问卷与访谈提纲
            ktfjFileList:[],//开题资料附件
            /*中期资料*/
            zqbgFileList:[],//中期报告
            yjgcFileList:[],//研究过程记录
            wtqdFileList:[],//问题清单
            hxjhFileList:[],//后续研究计划
            zqfjFileList:[],//中期资料附件
            //结题资料
            jtbgFileList:[],//结题报告
            gzbgFileList:[],//工作报告
            lwzzFileList:[],//论文与著作
            alkjFileList:[],//教学案例与课件
            hjzsFileList:[],//获奖证书
            jtfjFileList:[],//结题附件
            zlForm:{
                signId:'',
                fileType:2,
                fileUrls:'',
            },
        };
    },
    created() {
        this.userId = JSON.parse(this.$storage.get("userInfo")).userId
        this.signForm.trueName = JSON.parse(this.$storage.get("userInfo")).trueName
        this.signForm.orgId = JSON.parse(this.$storage.get("userInfo")).orgId
        this.signForm.orgName = JSON.parse(this.$storage.get("userInfo")).orgName
        this.getQueryDict();
    },
    mounted() {
        this.queryInfo()
        this.getTopicReleaseFile()
    },
    computed: {},
    methods: {
        getQueryDict() {
            /*档案学段学科*/
            queryDict({ code: 'archive_xd_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            /*最高学历*/
            queryDict({ code: 'qualification' }).then(res => {
                this.qualificationList = res.data.data;
            })
            /*技术职称*/
            queryDict({ code: 'technical_title' }).then(res => {
                this.rankList = res.data.data;
            })
        },
        changePeriod() {
            this.signForm.subjectKey = '';
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.signForm.periodKey == j.dictKey) {
                    this.subjectList = j.childrenList;
                }
            })
        },
        queryInfo(){
            leadDetail({ topicId: this.infoId }).then(res => {
                if (res.data.code===1){
                    var orgTxt = []
                    res.data.data.orgList.forEach(e => {
                        orgTxt.push(e.orgName)
                    })
                    res.data.data.orgTxt = orgTxt.join('、')
                    res.data.data.leaderName = ''
                    res.data.data.leaderList.forEach(e => {
                        if (res.data.data.leader == e.userId) {
                            res.data.data.leaderName = e.trueName
                        }
                    })
                    var checkUserTxt = []
                    res.data.data.checkUserList.forEach(e => {
                        checkUserTxt.push(e.trueName)
                    })
                    res.data.data.checkUserTxt = checkUserTxt.join('、')
                    this.info = res.data.data;
                    if (this.info.isApply===1){
                        this.isApply = 1;
                        this.signForm = this.info.topicSign;
                        queryDict({ code: 'archive_xd_xk' }).then(res => {
                            this.periodList = res.data.data;
                            this.subjectList = [];
                            this.periodList.forEach(j => {
                                if (this.signForm.periodKey == j.dictKey) {
                                    this.subjectList = j.childrenList;
                                }
                            })
                        })
                        //申报资料
                        this.signForm.xlFileList.forEach(e => {
                            this.xlFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.zcFileList.forEach(e => {
                            this.zcFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.clFileList.forEach(e => {
                            this.clFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        //开题资料
                        this.signForm.sbsFileList.forEach(e => {
                            this.sbsFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.tzsFileList.forEach(e => {
                            this.tzsFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.ktbgFileList.forEach(e => {
                            this.ktbgFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.hdjlFileList.forEach(e => {
                            this.hdjlFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.wjftFileList.forEach(e => {
                            this.wjftFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.ktfjFileList.forEach(e => {
                            this.ktfjFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        //中期资料
                        this.signForm.zqbgFileList.forEach(e => {
                            this.zqbgFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.yjgcFileList.forEach(e => {
                            this.yjgcFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.wtqdFileList.forEach(e => {
                            this.wtqdFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.hxjhFileList.forEach(e => {
                            this.hxjhFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.zqfjFileList.forEach(e => {
                            this.zqfjFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        //结题资料
                        this.signForm.jtbgFileList.forEach(e => {
                            this.jtbgFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.gzbgFileList.forEach(e => {
                            this.gzbgFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.lwzzFileList.forEach(e => {
                            this.lwzzFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.alkjFileList.forEach(e => {
                            this.alkjFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.hjzsFileList.forEach(e => {
                            this.hjzsFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.signForm.jtfjFileList.forEach(e => {
                            this.jtfjFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        /*学科*/
                        this.periodList.forEach(j => {
                            if (this.signForm.periodKey == j.dictKey) {
                                this.subjectList = j.childrenList;
                            }
                        })
                    }
                }
            })
        },
        getTopicReleaseFile(){
            releaseTopicFile({ topicId: this.infoId }).then(res => {
                if (res.data.code === 1) {
                    this.releaseInfo = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }

            })
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,fileType,fileUrl){
            const list = [];
            if (fileType &&(fileType.toLowerCase()==='png'||fileType.toLowerCase()==='jpg'||fileType.toLowerCase()==='jpeg')){
                list.push(fileUrl);
            }else {
                for (let i = 1; i <=page ; i++) {
                    list.push(baseUrl+'/' + i+'.png');
                }
            }

            return list;
        },
        changeModel(){
            this.$emit('change-mode', this.detailMode);
        },
        topicSignUp(text){
            this.showMode = this.signModel;
            this.applyBtnTxt = text;
        },
        viewTopicSignUp(){
          this.showMode = this.viewApplyModel
        },
        backTopicInfo(){
            this.showMode = this.detailMode
        },
        successConfirm(){
            this.showMode = this.detailMode
            this.queryInfo();
        },
        /*移除文件*/
        handleFileRemove(file, uploadFiles) {
            // if (file.response.data) {
            //     deleteTopicFile({ fileUrl: file.response.data }).then(res => {})
            // }
        },
        /*学历文件上传*/
        beforeXlUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
                rawFile.type === 'image/png' ||
              rawFile.type === 'image/jpg'||
              rawFile.type === 'image/jpeg')) {
                this.$message.error('暂不支持此类型文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 5) {
                this.$message.error('文件大小不得超过5M')
                return false
            }
            return true
        },
        /*职称证书文件上传*/
        beforeZcUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type === 'image/png' ||
              rawFile.type === 'image/jpg'||
              rawFile.type === 'image/jpeg')) {
                this.$message.error('暂不支持此类型文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 5) {
                this.$message.error('文件大小不得超过5M')
                return false
            }
            return true
        },
        /*证明材料文件上传*/
        beforeClUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
                  rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
              rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
              rawFile.type == 'application/msword')) {
                this.$message.error('暂不支持此类型文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('文件大小不得超过10M')
                return false
            }
            return true
        },
        /*提交报名*/
        submitTopicSign(){
            this.signForm.topicId = this.info.parentTopicId
            this.signForm.topicDirection = this.info.topicId
            const fileList = [];
            if (this.xlFileList.length === 0) {
                this.$message.error("请上传学历文件")
                return
            }
            this.xlFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            if (this.zcFileList.length === 0) {
                this.$message.error("请上传职称证书")
                return;
            }
            this.zcFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.clFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })

            this.$refs["signForm"].validate(valid => {
                if (valid) {
                    const obj = JSON.parse(JSON.stringify(this.signForm));
                    obj.fileUrls = fileList.toString();
                    signTopic(obj).then(res => {
                        if (res.data.code === 1) {
                            this.showMode = this.successMode;
                        }else {
                            this.$message.error("操作失败")
                        }
                    })
                }
            })
        },
        //上传开题资料
        uploadKtFile(text){
            this.showMode = this.ktFileModel;
            this.applyBtnTxt = text;

        },
        //提交资料
        submitKtFile(){
            this.zlForm.fileType = 2;
            const fileList = [];
            if (this.tzsFileList.length === 0) {
                this.$message.error("请上传立项通知书")
                return;
            }
            if (this.ktbgFileList.length === 0) {
                this.$message.error("请上传开题报告")
                return;
            }
            this.sbsFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.tzsFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.ktbgFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.hdjlFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.wjftFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.ktfjFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.zlForm.signId = this.signForm.signId;
            this.zlForm.fileUrls = fileList.toString();
            handleTopicFile(this.zlForm).then(res => {
                if (res.data.code === 1) {
                    this.showMode = this.successMode;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        //上传中期资料
        uploadZqFile(text){
            this.showMode = this.zqFileModel;
            this.applyBtnTxt = text;
        },
        submitZqFile(){
            this.zlForm.fileType = 3;
            const fileList = [];
            if (this.zqbgFileList.length === 0) {
                this.$message.error("请上传中期报告")
                return;
            }
            this.zqbgFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.yjgcFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.wtqdFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.hxjhFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.zqfjFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.zlForm.signId = this.signForm.signId;
            this.zlForm.fileUrls = fileList.toString();
            handleTopicFile(this.zlForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("资料已提交");
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        //上传结题资料
        uploadJtFile(text){
            this.showMode = this.jtFileModel;
            this.applyBtnTxt = text;
        },
        submitJtFile(){
            this.zlForm.fileType = 4;
            const fileList = [];
            if (this.jtbgFileList.length === 0) {
                this.$message.error("请上传结题报告")
                return;
            }
            if (this.alkjFileList.length === 0) {
                this.$message.error("请上传案例与课件")
                return;
            }
            this.jtbgFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.gzbgFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.lwzzFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.alkjFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.hjzsFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.jtfjFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.zlForm.signId = this.signForm.signId;
            this.zlForm.fileUrls = fileList.toString();
            handleTopicFile(this.zlForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("资料已提交");
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
    }
};
</script>
<style scoped>
.course-container{
    width: 100%;
    height: auto;
    //padding-left: 15px;
    padding-bottom: 10px;
    padding-right: 5px;
    box-sizing: border-box;
}
.topic-detail{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.sub-topic-top{
    width: calc(100% - 225px);
    height: 90px;
    background-color: #0d55a4;
    display: flex;
    position: fixed;
    top: 80px;
    left: 210px;
    z-index: 999;
}
.topic-top-left{
    width: calc(100% - 200px);
    height: 100%;
}
.top-left1{
    height: 50px;
    width: 100%;
    color: #fff;
    line-height: 60px;
    text-indent: 30px;
    font-size: 20px;
    font-weight: bold;
    display: flex;
}
.status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #00a173;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-kt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-zq{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-jt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-js{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #54bcbd;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.top-left2{
    height: 50px;
    width: 100%;
    color: #fff;
    text-indent: 30px;
    font-size: 15px;
    font-weight: bold;
}
.topic-top-right{
    width: 200px;
    height: 100%;
    display: flex;
}
.right-ntn{
    width: 90px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.bm-btn{
    width: 80px;
    height: 30px;
    background-color: #fff;
    color: #0d55a4;
    font-size: 14px;
    border-radius: 4px;
    line-height: 30px;
    text-align: center;
    margin: auto;
    font-weight: bold;
    cursor: pointer;
}
.topic-container{
    width: 100%;
    height: auto;
    background-color: #fff;
    padding-top: 100px;
}
.topic-name-container{
    width: 100%;
    height: 50px;
    line-height: 48px;
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    box-sizing: border-box;
    padding-left: 15px;

}
.topic-time-container{
    width: 100%;
    height: 260px;
    box-sizing: border-box;
    padding-left: 30px;
}
.topic-time-top{
    width: 100%;
    height: 30px;
    display: flex;
}
.topic-time-top1{
    width: 24px;
    height: 30px;
}
.topic-time-top2{
    width: calc(100% - 24px);
    height: 30px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
}
.topic-jd{
    width: 100%;
    height: 24px;
    display: flex;
}
.topic-jd1{
    width: 24px;
    height: 30px;
}
.topic-point{
    width: 10px;
    height: 10px;
    background-color: #0d55a4;
    border-radius: 5px;
    margin-top: 6px;
}
.topic-jd2{
    width: calc(100% - 24px);
    height: 30px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
}
.topic-jd-time{
    height: 30px;
    border-left: 2px solid #0d55a4;
    margin-left: 4px;
    text-indent: 20px;
    font-size: 14px;
    color: #767676;
    font-weight: bold;
}
.topic-jd-time-end{
    height: 30px;
    margin-left: 4px;
    text-indent: 20px;
    font-size: 14px;
    color: #767676;
    font-weight: bold;
}
.topic-title-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.topic-title-container1{
    width: 50px;
    height: 40px;
    padding-left: 16px;
    box-sizing: border-box;
    padding-top: 8px;
}
.topic-title-container2{
    width: calc(100% - 50px);
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #0d55a4;
}
.topic-base-info-container{
    width: 100%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
}
.base-one-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.base-one-info{
    width: 40%;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.base-one-info-80{
    width: 80%;
    height: auto;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.topic-content-container{
    width: 100%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
    text-indent: 30px;
    font-size: 14px;
    color: #767676;
    line-height: 24px;
    word-break: break-all;
}
.topic-content-container-img{
    width: 100%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
    font-size: 14px;
    color: #767676;
    line-height: 24px;
}

.topic-sign-title-second{
    display: flex;
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    padding-left: 50px;
    box-sizing: border-box;
}

.topic-file-container-second{
    width: calc(100% - 90px);
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
    margin-left: 50px;
}
.file-item-second{
    display: flex;
    height: 30px;
    width: 100%;
    padding-right: 30px;
    box-sizing: border-box;
    cursor: pointer;
}
.file-item-second:hover{
    color: #0d55a4!important;
    font-weight: bold;
}
.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 50px;
    padding-right: 50px;
    box-sizing: border-box;
    cursor: pointer;
}
.file-item:hover{
    color: #0d55a4!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
}
.file-view{
    width: 30px;
    height: 100%;
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.back-btn-container{
    width: 100%;
    height: 60px;
    background-color: #fff;
    padding-top: 15px;
    box-sizing: border-box;
}
.back-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 6px;
    background-color: #0d55a4;
    font-size: 14px;
    text-align: center;
    color: #fff;
    margin: auto;
    cursor: pointer;
    font-weight: bold;
}
.topic-sign-container{
    width: 100%;
    height: auto;
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 10px;
    box-sizing: border-box;
}
.topic-sign-title{
    display: flex;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 5px;
    margin-top: 5px;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    //line-height: 30px;
    font-size: 15px;
    color: #767676;
}
.topic-sign-form{
    width: 100%;
    height: auto;
}
.item-title-tio{
    font-size: 14px;
    color: #767676;
    font-weight: normal!important;
    margin-left: 60px;
}
/deep/ .el-form-item{
    //margin-bottom: 10px!important;
}
/deep/ .el-form-item__label{
    color:#333333!important;
    font-weight:bold;
    font-size:13px
}

.topic-file-container{
    width: 98%;
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
}
.topic-file-item-title{
    height: 30px;
    color:#333333;
    font-weight:bold;
    font-size:14px
}
.upload-btn-container{
    width: 160px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #0d55a4;
    color: #fff;
    border-radius: 5px;
    display: flex;
}
.upload-btn-tip{
    text-indent: 40px;
    line-height: 40px;
    font-size: 13px;
    font-weight: bold;
    color: #767676;
}

.apply-btn-container-back{
    width: 100%;
    height: 50px;
}
.apply-btn-back{
    width: 80px;
    height: 34px;
    line-height: 34px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #0d55a4;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}


.apply-btn-container{
    width: 200px;
    height: 40px;
    padding-top: 30px;
    display: flex;
    margin: auto;
}
.apply-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #0d55a4;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.apply-btn-back{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #FFFFFF;
    color: #909399;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
    border: 1px solid #909399;
}

.bg-dsh{
    background-color: #93d2f3;
    color: #fff!important;
}
.bg-ytg{
    background-color: #81b336;
    color: #fff!important;
}
.bg-wtg{
    background-color: #bd3124;
    color: #fff!important;
}



.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 20px;
    padding-right: 50px;
    box-sizing: border-box;
    cursor: pointer;
}
.file-item:hover{
    color: #0d55a4!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
}
.file-view{
    width: 30px;
    height: 100%;
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}

/*申报成功*/
.success-container{
    width: 100%;
    height: calc(100vh - 100px);
    overflow-y: hidden;
    background-color: #fff;
}
.success-content-container{
    width: 40%;
    height: 100%;
    margin: auto;
}
.success-title{
    width: 100%;
    height: 80px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    color: #000;
}
.success-icon{
    width: 64px;
    height: 124px;
    padding-top: 60px;
    box-sizing: border-box;
    margin: auto;
}
.success-item-container{
    width: 100%;
    height: auto;
    display: flex;
    padding-bottom: 5px;
}
.success-item-title{
    width: 140px;
    font-size: 15px;
    color: #767676;
    text-align: right;
}
.success-item-content{
    width: calc(100% - 140px);
    height: auto;
    line-height: 20px;
    font-size: 15px;
    color: #333;
    text-align: left;
    padding-left: 15px;
    box-sizing: border-box;
}
.success-btn{
    width: 100px;
    height: 36px;
    line-height: 36px;
    margin: auto;
    margin-top: 50px;
    text-align: center;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #0d55a4;
    cursor: pointer;
}
</style>

